import Image from 'next/image';

type CountryCardProps = {
  flagUrl: string;
  countryName: string;
  language: string;
  currencyLabel: string;
  onClick: () => void;
};

export default function CountryCard({
  flagUrl,
  countryName,
  language,
  currencyLabel,
  onClick,
}: CountryCardProps) {
  return (
    <button
      onClick={onClick}
      className="w-full p-3 flex items-center gap-3 hover:bg-[#EEEEEE]/50 transition"
    >
      <Image
        src={flagUrl}
        alt={countryName}
        width={32}
        height={24}
        className="w-8 h-6"
      />
      <div>
        <p className="font-semibold text-left font-proxima_font text-base">
          {countryName}
        </p>
        <p className="text-sm font-proxima_font">
          <span>{language}</span>
          <span> / </span>
          <span>{currencyLabel}</span>
        </p>
      </div>
    </button>
  );
}
